import BookShelf from './Bookshelf.vue';
import BookShelfList from './BookshelfList.vue';
export default { BookShelf, BookShelfList };
